/* eslint-disable @next/next/no-img-element -- fotos de perfil remotas (Cloudinary), tamaño chico fijo */
import { cn } from "@/lib/utils";
import type { PlayerCard } from "@/lib/daily-word";

// Avatar de un jugador: su foto, o uno generado estilo GitHub (grilla 5×5
// simétrica con un color propio) a partir de su huella `avatarSeed`. Siempre
// el mismo para la misma persona, sin revelar quién es.
export function PlayerAvatar({ player, size = 36, className }: { player: PlayerCard; size?: number; className?: string }) {
  const style = { width: size, height: size };
  if (player.avatarUrl) {
    return (
      <img
        src={player.avatarUrl}
        alt=""
        width={size}
        height={size}
        style={style}
        className={cn("shrink-0 rounded-full object-cover", className)}
      />
    );
  }
  const { cells, color } = identicon(player.avatarSeed);
  return (
    <svg
      viewBox="-0.5 -0.5 6 6"
      width={size}
      height={size}
      aria-hidden
      className={cn("shrink-0 rounded-full bg-muted", className)}
    >
      {cells.map(([x, y]) => (
        <rect key={`${x}-${y}`} x={x} y={y} width={1} height={1} fill={color} />
      ))}
    </svg>
  );
}

// 15 bits deciden las 3 columnas de la izquierda (la derecha es espejo); el
// resto, el tono del color.
function identicon(seed: string): { cells: [number, number][]; color: string } {
  const bits = parseInt(seed.slice(0, 8), 16) || 0;
  const hue = (parseInt(seed.slice(8, 12), 16) || 0) % 360;
  const cells: [number, number][] = [];
  for (let col = 0; col < 3; col++) {
    for (let row = 0; row < 5; row++) {
      if ((bits >> (col * 5 + row)) & 1) {
        cells.push([col, row]);
        if (col < 2) cells.push([4 - col, row]);
      }
    }
  }
  return { cells, color: `hsl(${hue} 65% 50%)` };
}
